import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  rootContainer: {
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  ctnModal: {
    maxWidth: 490,
    backgroundColor: "#fff",
    boxShadow: theme.shadows[5],
    top: "35%",
    margin: "auto",
    borderRadius: "12px",
    overflow: "hidden",
    outline: "none",
    width: "90%",
    [theme.breakpoints.up("sm")]: {
      width: "100%",
    },
    "& > #padding-content": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "32px 28px",

      "& > #title": {
        fontSize: "24px",
        fontWeight: "800",
        lineHeight: "24px",
        [theme.breakpoints.down("sm")]: {
          fontSize: "20px",
        }
      },
    },
  },
  ctnCountry: {
    display: "flex",
    flexWrap: "wrap",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
    [theme.breakpoints.up("sm")]: {
      justifyContent: "space-between"
    },
  },
  ctnCountryItem: {
    marginTop: 26,
    [theme.breakpoints.up("sm")]: {
      width: "48%", marginTop: 32,
    },
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "& > img": {
      width: 31,
      height: 31,
      objectFit: "contain",
      marginRight: 12,

      [theme.breakpoints.down("sm")]: {
        width: 27,
        height: 27,
      }
    },
    "&> span": {
      fontSize: 18,
      fontWeight: 700,
      color: "#000",

      [theme.breakpoints.down("sm")]: {
        fontSize: 16
      }
    }
  }
}));

export default useStyles;
